export const getDeviceBindingPayload = async () => {
  const platform = (typeof window !== 'undefined' && window.HardayAndroid?.getDeviceInstallId) ? 'android_app' : 'website';
  let installId = '';
  try {
    if (platform === 'android_app') {
      installId = window.HardayAndroid.getDeviceInstallId();
    }
  } catch {}
  try {
    if (!installId) {
      installId = localStorage.getItem('hardayDeviceInstallId');
      if (!installId) {
        installId = (crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`).toString();
        localStorage.setItem('hardayDeviceInstallId', installId);
      }
    }
  } catch {
    installId = `volatile-${Date.now()}-${Math.random()}`;
  }
  const nav = typeof navigator !== 'undefined' ? navigator : {};
  const scr = typeof window !== 'undefined' ? window.screen : {};
  const raw = [
    platform,
    installId,
    nav.userAgent || '',
    nav.platform || '',
    nav.language || '',
    `${scr.width || 0}x${scr.height || 0}x${scr.colorDepth || 0}`,
    Intl.DateTimeFormat().resolvedOptions().timeZone || '',
  ].join('|');
  let deviceFingerprint = raw;
  try {
    const bytes = new TextEncoder().encode(raw);
    const digest = await crypto.subtle.digest('SHA-256', bytes);
    deviceFingerprint = Array.from(new Uint8Array(digest)).map((b) => b.toString(16).padStart(2, '0')).join('');
  } catch {}
  return { deviceFingerprint, platform };
};
